import Card, { CardContent } from '@cobliteam/colib-ui/Card';
import useGlobalFilterStore from '@cobliteam/hooks/src/useGlobalFilterStore';
import ItemSidebar from '../components/ItemSidebar';
import { trackGlobalSearchEvents } from '../helpers';
import { useSearch } from '../hooks/useSearch';
import type { EnumCategory } from '../types';

const DisclaimerFilterGroups = () => {
  return (
    <div className='p-4'>
      <Card size='sm'>
        <CardContent>
          <div className='text-muted-foreground text-xs'>
            <span className='font-bold'>Atenção: </span>
            <span className='text-balance'>Os resultados estão filtrados pelo filtro de grupos de veículos.</span>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

const GlobalSearchSidebar = () => {
  const { onChangeCategory, category, counts, sidebar } = useSearch();
  const vehicleGroupIds = useGlobalFilterStore((state: any) => state.vehicleGroupIds);

  const handleCategoryChange = (params: { categoryId: string; keepSearch: boolean }) => {
    onChangeCategory(params);
    trackGlobalSearchEvents.categoryChange(params.categoryId as EnumCategory);
  };

  return (
    <div className='flex h-full flex-col justify-between text-xs'>
      <div>
        {sidebar.map((group) => {
          return (
            <div key={group.name}>
              {group.categories.map((item) => {
                return <ItemSidebar key={item.id} item={item} active={category.id === item.id} onChangeCategory={handleCategoryChange} counts={counts} />;
              })}
            </div>
          );
        })}
      </div>

      {vehicleGroupIds.length > 0 && <DisclaimerFilterGroups />}
    </div>
  );
};

export default GlobalSearchSidebar;
